import type { ToastContent } from '@faro/design-system';
import { formatError } from './formatError';

export function errorToast(message: string, error: unknown): ToastContent {
    return {
        head: message,
        body: formatError(error),
    };
}
